export default class Component {

    constructor($element) {
        this.$element = $element;
        this.element = $element[0];
        this._name = this.constructor.name;
    }

    prepare() {
        console.warn(`Komponenta ${this._name} nemá metodu prepare().`);
    }

    destroy() {
        //console.warn('Destroy method: override me');
    }

    getElement() {
        return this.$element;
    }

    getRef(ref) {
        return `[data-ref="${ref}"]`;
    }

    getRefElement(ref, context = this.$element) {
        return $(`[data-ref="${ref}"]`, context);
    }

    static getFromElement($element) {
        return $element.data('__instance');
    }

}


// WEBPACK FOOTER //
// ./core/Component.js